import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FcmPush } from '@/services/fcm-push.plugin';

/** Сброс счётчика на иконке приложения (iOS badge / Android delivered). */
export async function clearAppIconBadge(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    if (Capacitor.getPlatform() === 'ios') {
      await FcmPush.clearBadge();
    } else {
      await PushNotifications.removeAllDeliveredNotifications();
    }
  } catch (error) {
    console.warn('[push] clear badge failed', error);
  }
}
